import { TFasterPayoutStatus } from '../../../../../api/src';

export function getFasterPayoutBadgeVariant(status: TFasterPayoutStatus) {
  switch (status) {
    case 'Created':
    case 'Pending':
    case 'Ready':
      return 'yellow';
    case 'Success':
      return 'green';
    case 'Rejected':
      return 'red';
    default:
      return undefined;
  }
}
